export default __webpack_public_path__ + "static/media/image2.11aa6430.png";